export enum RecrutimentSelfServiceType {
    ADDRESS_DECLARATION = 'ADDRESS_DECLARATION',
    EMPLOYMENT_HISTORY = 'EMPLOYMENT_HISTORY',
    FIRST_EMPLOYMENT = 'FIRST_EMPLOYMENT',
    PAYMENT_DETAILS_CHANGE = 'PAYMENT_DETAILS_CHANGE',
    PERSONAL_CONTACTS_DETAILS = 'PERSONAL_CONTACTS_DETAILS',
    PREVIOUS_WORK_ACTIVITIES = 'PREVIOUS_WORK_ACTIVITIES',
    RETIREMENT_PLAN = 'RETIREMENT_PLAN',
    TFR_DECLARATION = 'TFR_DECLARATION',
    DETASSAZIONE_COMMERCIO = 'DETASSAZIONE_COMMERCIO',
    DETASSAZIONE_TURISMO = 'DETASSAZIONE_TURISMO'
}

export enum AddressDeclarationKind {
    ITALIAN = 'ITALIAN',
    FOREIGN = 'FOREIGN'
}

export enum EmploymentHistoryKind {
    NO_PREVIOUS_EMPLOYMENT = 'NO_PREVIOUS_EMPLOYMENT',
    WITH_PREVIOUS_EMPLOYMENT = 'WITH_PREVIOUS_EMPLOYMENT'
}

export enum TimeRange {
    LAST_6_MONTHS = 'LAST_6_MONTHS',
    LAST_24_MONTHS = 'LAST_24_MONTHS',
    NONE = 'NONE'
}